// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

const Styles = {
  label: ({ isRequired }) => ({
    color: isRequired ? Colors.lava : Colors.steel,
    fontSize: '11px',
    paddingRight: '3px',
  }),
};

const RequiredOrOptionalLabel = ({
  isRequired,
  styles,
}: {
  isRequired: boolean,
  styles?: {},
}) => {
  const style = {
    ...Styles.label({ isRequired }),
    ...styles,
  };
  return <span css={style}>({isRequired ? 'required' : 'Optional'})</span>;
};

export default RequiredOrOptionalLabel;
